import { get, post } from "@/utils/axios";

// 提交AI绘画v2
export function postAIWork(data = {}) {
  return post("/api/v2/work", data);
}

//提交AI生图v3
export function postAIWorkV3(data = {}) {
  return post("/api/v3/work", data);
}

// 我的作品
export function getUserWorkList(data = {}) {
  return get("/api/v2/work/list", data);
}

// 查询作品合成状态
export function getWorkStatus(data = {}) {
  return post("/api/v2/work/status", data);
}

// 提交AI改图v2
export function postAIWorkEdit(data = {}) {
  return post("/api/v2/work/edit", data);
}

// 保存改图结果
export function saveWorkImage(data = {}) {
  return post("/api/v2/work/edit/save", data);
}

// 场景自动识别
export function themeIdentify(data = {}) {
  return get("api/v2/themeIdentify", data)
}

// 热门作品-分类
export function getHotWorkTypeList(data = {}) {
  return get("api/v2/hotTheme", data)
}
// tips列表
export function getTipsList(data = {}) {
  return get("api/v2/tips/list", data)
}


// 作品-删除
export function deleteWork(data = {}) {
  return post("api/v2/work/delete", data)
}

//查询最新项目列表
export function getProjectLatestList(data = {}) {
  return get("api/v3/project/latestList", data)
}

//查询项目列表
export function getProjectList(data = {}) {
  return get("api/v3/project/list", data)
}

//查询项目数据
export function getProjectDetail(data = {}) {
  return get("api/v3/project/detail", data)
}

//创建项目
export function createProject(data = {}) {
  return post("/api/v3/project", data);
} 

//编辑项目
export function editProject(data = {}) {
  return post("/api/v3/project/edit", data);
} 

//删除项目
export function deleteProject(data = {}) {
  return post("/api/v3/project/delete", data);
} 

//删除项目的图片
export function deleteProjectImage(data = {}) {
  return post("/api/v3/project/deleteImg", data);
} 

//查询收藏列表
export function getCollectList(data = {}) {
  return get("api/v3/userCollect/list", data)
}

//收藏
export function createCollect(data = {}) {
  return post("/api/v3/userCollect", data);
} 

//取消收藏
export function cancelCollect(data = {}) {
  return post("/api/v3/userCollect/cancel", data);
}

//作图记录
export function getUserWorkListV3(data = {}) {
  return get("api/v3/project/workList", data);
}

//描述词历史列表
export function getUserDescriptorHistoryList(data = {}) {
  return get("api/v3/userDescriptorHistory/list", data);
}

//编辑描述词历史
export function editUserDescriptorHistory(data = {}) {
  return post("/api/v3/userDescriptorHistory/edit", data);
} 

//解析图片
export function getAnalyzeImg(data = {}) {
  return get("api/v3/analyzeImg", data);
}

// 提交AI改图v3
export function postAIWorkEditV3(data = {}) {
  return post("/api/v3/work/edit", data);
}

//根据解析的图片themeid 查询风格列表
export function getThemeStyleList(data = {}) {
  return get("api/v3/themeStyle/list", data);
}

// 模型风格及其属性列表
export function getModelStyleAttributeList(data = {}) {
  return get("api/v3/modelStyleAttributeList", data);
}

//分享作品到首页
export function shareToHot(data = {}) {
  return post("/api/v3/shareImgIndex", data);
}
//提交AI生图v4
export function postAIWorkV4(data = {}) {
  return post("/api/v4/work", data);
}

// 提交AI改图v4
export function postAIWorkEditV4(data = {}) {
  return post("/api/v4/work/edit", data);
}

// 查询作品合成状态v4
export function getWorkStatusV4(data = {}) {
  return post("/api/v4/work/status", data);
}

// 工具集列表
export function getToolList(data = {}) {
  return get("/api/v4/tools/list", data);
}
// 设置项目可分享
export function setProjectShare(data = {}) {
  return post("/api/v4/project/share", data);
}
// 项目克隆
export function cloneProject(data = {}) {
  return post("/api/v4/project/clone", data);
}
// 描述词反推
export function getDescriptorReverse(data = {}) {
  return post("/api/v4/reversePrompt", data);
}
// 查询图片ID
export function getImgIdByImgUrl(data = {}) {
  return post("/api/v4/img/md5/query", data);
}
/**
 * 参考图裁剪
 * @param {string} data.image_url - 图片URL地址
 * 示例： https://aiimg.3d66.com/test/jimeng/jiemeng_180275492286304.png?x-oss-process=image/crop,x_0,y_0,w_1573,h_825
 * @returns
 */
export function setReferenceImageCut(data = {}) {
  return post("/api/v4/img/referenceImageCut", data);
}
// 终止任务
export function setWorkTerminate(data = {}) {
  return post("/api/v4/work/terminate", data);
}
// 根据工具ID查询快捷描述词
export function getQuickWordsById(data = {}) {
  return get("/api/v4/quickDescriptor/listByTools", data);
}
// 获取快捷描述词分类树
export function getQuickWordsTree(data = {}) {
  return get("/api/v4/quickDescriptor/class/tree", data);
}
// 根据分类ID查询快捷描述词
export function getQuickWordsByClassId(data = {}) {
  return get("/api/v4/quickDescriptor/list", data);
}
// 推荐快捷描述词
export function getRecommendQuickWords(data = {}) {
  return get("/api/v4/quickDescriptor/recommend", data);
}

// 获取风格列表
export function getStyleList(data = {}) {
  return get("/api/v1/rendering/style/index", data);
}

// 创建渲染作品
export function createRenderWork(data = {}) {
  return post("/api/v1/rendering/works/create", data);
}
export function createVrRenderWork(data = {}) { return post("/api/v1/vr/rendering/works/create", data); }

// 渲染作品详情
export function getRenderWorkDetail(data = {}) {
  return get("/api/v1/rendering/works/detail", data);
}

// 渲染作品列表
export function getRenderWorkList(data = {}) {
  return get("/api/v1/rendering/works/list", data);
}

// 渲染作品状态查询
export function getRenderWorkStatus(data = {}) {
  return get("/api/v1/rendering/works/status", data);
}

// 保存渲染图片到插件
export function saveRenderImgToPlugin(data = {}) {
  return post("/api/v1/rendering/user/plugin/imgSave", data);
}

// 渲染参数配置列表
export function getRenderConfigList(data = {}) {
  return get("/api/v1/rendering/config/list", data);
}

// 获取渲染模板场景列表
export function getRenderTemplateScenes(data = {}) {
  return get("/api/v1/rendering/template/scenes", data);
}

// 新增自定义渲染模板场景
export function createRenderTemplateScene(data = {}) {
  return post("/api/v1/rendering/template/scenes/create", data);
}

// 编辑自定义渲染模板场景
export function updateRenderTemplateScene(data = {}) {
  return post("/api/v1/rendering/template/scenes/update", data);
}

// 删除自定义渲染模板场景
export function deleteRenderTemplateScene(data = {}) {
  return post("/api/v1/rendering/template/scenes/delete", data);
}

// 保存渲染模板
export function saveRenderTemplate(data = {}) {
  return post("/api/v1/rendering/template/save", data);
}

// 获取渲染模板列表
export function getRenderTemplateList(data = {}) {
  return get("/api/v1/rendering/template/list", data);
}

// 编辑渲染模板
export function updateRenderTemplate(data = {}) {
  return post("/api/v1/rendering/template/update", data);
}

// 删除渲染模板
export function deleteRenderTemplate(data = {}) {
  return post("/api/v1/rendering/template/delete", data);
}


export function getVrRenderConfigList(data = {}) {
  return get("/api/v1/vr/rendering/config/list", data);
}

// 获取风格列表
export function getStylePromptList(data = {}) {
  return get("/api/v1/rendering/config/prompt/list", data);
}

export function getVrStylePromptList(data = {}) {
  return get("/api/v1/vr/rendering/config/prompt/list", data);
}

// 获取精细渲染默认参数配置（场景参数回显）
export function getPreciseConfig(data = {}) {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (data[key] != null) formData.append(key, data[key]);
  });
  return post("/api/v1/rendering/config/getPreciseConfig", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 渲染图片下载
export function downloadRenderImage(data = {}) {
  return post("/api/v1/rendering/works/downloadImg", data);
}


// 方案推敲-获取模板列表（试用推敲的模板及其结果图）
export function getPlanRefinementTempList(data = {}) {
  return post("/api/v1/planRefinement/config/tempList", data);
}


// 方案推敲-获取配置
export function getPlanRefinementConfigList(data = {}) {
  return post("/api/v1/planRefinement/config/list", data);
}

// 方案推敲-创建任务
export function createPlanRefinementWork(data = {}) {
  return post("/api/v1/planRefinement/works/create", data);
}

// 方案推敲-任务列表
export function getPlanRefinementWorkList(data = {}) {
  return post("/api/v1/planRefinement/works/list", data);
}

// 方案推敲-任务状态查询
export function getPlanRefinementWorkStatus(data = {}) {
  return post("/api/v1/planRefinement/works/status", data);
}

// 方案推敲-校验用户账户是否足够本次支付
export function getPlanRefinementCheckUserTops(data = {}) {
  return post("/api/v1/planRefinement/works/checkUserTops", data);
}

// 校验用户是否参与引导（type: 1-方案推敲引导 2-平面填彩引导），is_guid: 1-弹出引导 0-不弹出
export function checkUserGuid(type = 1) {
  return post("/api/v1/user/checkUserGuid", {}, { params: { type } });
}

// 方案推敲-图片下载
export function getPlanRefinementDownloadImg(data = {}) {
  return post("/api/v1/planRefinement/works/downloadImg", data);
}

// 图片敏感度检查
export function checkImgSensitive(data = {}) {
  return post("/api/v1/image/checkSensitiveImg", data);
}